import React, { useState, useEffect } from 'react';
import Layout from '../../core/Layout';
import { getMyOrders, getProduct, findManyProducts, getUserInfo } from '../apiUser';
import { isAuthenticated } from '../../auth';
import { CheckCircleIcon, ChevronRightIcon, MailIcon, RefreshIcon, ChatIcon } from '@heroicons/react/solid'
import BadgeCondition from './BadgeCondition';

const Orders = () => {
    const { user: {_id}, token } = isAuthenticated();

    const [loading, setLoading] = useState(true);
    
    const [myUserData, setMyUserData] = useState({});
    const [orders, setOrders] = useState([]);


    useEffect(() => {
        getMyOrders(_id, token).then(async data => {
            getUserInfo(_id).then(myInfo => {
                setMyUserData(myInfo);
            });


            await data.forEach(async order => {
                //check if payment has been processed
                //
                let orderElm = {order: order, recieverItem: {}, senderItems: [], recieverData: {}, senderData: {}, recieverLink: '', senderLink: ''};

                if (order.recieverPaymentStatus === 'succeeded') {
                    orderElm['recieverLink'] = `/order/order-status/${order._id}`;
                }
                else {
                    orderElm['recieverLink'] = `/order/generate-shipping/${order._id}`;
                }

                if (order.senderPaymentStatus === 'succeeded') {
                    orderElm['senderLink'] = `/order/order-status/${order._id}`;
                }
                else {
                    orderElm['senderLink'] = `/order/generate-shipping/${order._id}`;
                }

                //fetch users data
                getUserInfo(order.reciever).then(recieverInfo => {
                    orderElm['recieverData'] = recieverInfo;
                });

                getUserInfo(order.sender).then(senderInfo => {
                    orderElm['senderData'] = senderInfo;
                });

                await getProduct(order.recieverItemId).then(recieverItemData => {
                    orderElm['recieverItem'] = recieverItemData;
                });

                //find mnay here for sender item data
                await findManyProducts(order.senderItemIds).then(senderItemsData => {
                    orderElm['senderItems'] = senderItemsData;
                });

                await setOrders(orders => [...orders, orderElm]);
            });


        });
    },[]);



    return (
        <Layout className='lg:px-40 mx:px-20 py-8 sm:px-3'>
            <h3 className="text-xl leading-6 font-medium text-gray-900">Orders</h3>
            <div className='bg-white shadow overflow-hidden sm:rounded-md'>
                <ul className='divide-y divide-gray-200'>
                    {orders.map((order, i) => (
                        <li key={i}>
                            <a href={order.order.reciever === _id ? order.recieverLink : order.senderLink} className="block hover:bg-gray-50"> {/* change link with state  */}
                                <div className="flex items-center px-4 py-4 sm:px-6">
                                    <div className="min-w-0 flex-1 flex items-center">
                                        <div className="flex-shrink-0">
                                            { order.recieverData._id === _id ?
                                                <img className="h-12 w-12 rounded-full" src={order.senderData.profile_picture} alt="" />
                                                :

                                                <img className="h-12 w-12 rounded-full" src={order.recieverData.profile_picture} alt="" />
                                            }
                                        </div>
                                        <div className="min-w-0 flex-1 px-4 md:grid md:grid-cols-2 md:gap-4">
                                            <div>
                                                { order.recieverData._id === _id ?
                                                    <>
                                                        <p className="text-sm font-medium text-indigo-600 truncate">{order.senderData.name}</p>
                                                        <BadgeCondition order={order.order} _id={_id}/> 

                                                    </>
                                                    :
                                                    <>
                                                        <p className="text-sm font-medium text-indigo-600 truncate">{order.recieverData.name}</p>
                                                        <BadgeCondition order={order.order} _id={_id}/> 
                                                    </>
                                                }
                                                <p className="mt-2 items-center text-sm text-gray-500">
                                                    <span className='flex truncate'>{order.recieverItem.name} <RefreshIcon className='h-5 w-5 mx-2'/>
                                                        {order.senderItems.map((senderItem, i) => (
                                                            <>
                                                                {senderItem.name}{i !== order.senderItems.length-1 ? ', ' :''}
                                                            </>
                                                        ))}
                                                    </span>
                                                </p>
                                            </div>
                                            <div className="md:block">
                                                {/*new message was here */}
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <ChevronRightIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                    </div>
                                </div>
                            </a>
                        </li>


                    ))}
                </ul>
            </div>
        </Layout>
    );
};

export default Orders;
